import * as React from "react";
import { BusinessServiceDescriptor } from "src/businessServices";
import { Bom2aView } from "./Bom2aView";

/*
 * Специальная версия для кухенлэнд
 */

export const bsBom2a: BusinessServiceDescriptor = {
  key: "BOM Kuchenland",
  viewer(info, data) {
    return <Bom2aView info={info} entityData={data} />;
  },

  // Настроек тут нет
  renderSettings() {
    return null;
  },
  async loadSettings() {
    return {};
  },
  async saveSettings() {
    return Promise.resolve();
  },
};
